import React from 'react';
import { IconBase } from '../Base';
export const IconEventIncoming = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M5.75 5.75L14.25 14.25", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M14.25 7.25V14.25H7.25", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Incoming.js.map